Apt.fn.make('gallery', {
	/**
	 * Initialize module
	 *
	 * @param {Object} options
	 * @returns {Object}
	 */
	init(options) {
		const scope = this;
		const priv = scope.$private;

		scope.conf = Object.assign({
			type: 'image',
			context: {}
		}, options);

		scope.uid = LS.util.uid();

		const type = scope.conf.type;

		priv.total = options.app.$get('total_' + type + 's');

		if (priv.total > 1) {
			if (options.large && type === 'image') {
				priv.fetched = true;

				priv.process(scope.conf, scope.conf.data);
			}

			scope.resume();

			const preload = options.preload;

			if (preload || options.value) {
				priv.fetch(options.value || 'next', preload);
			}
		}

		$('img', options.delegate)
			.first()
			.on('error', () => {
				priv.log();
			});

		return scope;
	},

	/**
	 * Set gallery position
	 *
	 * @param {Number|String} value
	 * @param {Boolean} [preload=false]
	 */
	move(value, preload) {
		this.$private.fetch(value, preload);
	},

	/**
	 * Preload image
	 *
	 * @param {Number} value
	 */
	preload(value) {
		new Image().src = this.$private.images[value - 1].path;
	},

	/**
	 * Pause events
	 */
	pause() {
		const uid = this.uid;

		$.fetch.abort(uid);
		$.events.reset(uid);
	},

	/**
	 * Resume events
	 */
	resume() {
		const scope = this;
		const conf = scope.conf;

		if (conf.bind) {
			$.events.on('$next, $prev', 'mousedown', (e, el) => {
				if (e.button === 2) {
					return;
				}

				scope.move(el.dataset.action || 'prev');
			}, {
				delegate: conf.delegate,
				namespace: scope.uid
			});

			if (conf.large) {
				$(document).on('keydown', e => {
					const key = e.keyCode;

					if (key === 37 || key === 39) {
						const active = document.activeElement;

						if (active && active.form) {
							return;
						}

						scope.move(
							key === 39 ?
								'next' : 'prev'
						);
					}
				}, {
					namespace: scope.uid
				});
			}
		}
	},

	/**
	 * Destroy module
	 *
	 * @private
	 */
	_destruct() {
		const scope = this;

		scope.$private.state(true);

		scope.pause();

		scope.conf.app = null;
	}
}, {
	/**
	 * Process gallery request
	 *
	 * @param {Number|String} value
	 * @param {Boolean} [preload=false]
	 */
	fetch(value, preload) {
		const scope = this;
		const pub = scope.$public;
		const conf = pub.conf;

		if (! conf.app) {
			return;
		}

		if (conf.type === 'video') {
			if (preload) {
				return;
			}

			scope.set(value);

			return;
		}

		if (scope.processed && ! preload) {
			scope.load(value);

			return;
		}

		if (preload) {
			scope.loading = true;
		} else {
			scope.state();

			if (scope.loading) {
				scope.loading = 'load';

				return;
			}

			scope.loading = true;
		}

		const thumbnails = conf.app.$get('thumbnails');

		if (thumbnails) {
			scope.fetched = true;

			scope.process(conf, thumbnails);

			if (! preload || scope.loading === 'load') {
				scope.load(value);
			}

			delete scope.loading;

			return;
		}

		LS.api.get(`listings/${conf.id}/thumbnails`, {
			namespace: pub.uid,
			flash: false,
			proxy: true,
			success: data => {
				if (! conf.app) {
					return;
				}

				scope.fetched = true;

				if (
					data.code === 301 ||
					data.code === 302
				) {
					LS.util.flash('Inactive listing — search nearby');

					return;
				}

				scope.process(conf, data);

				if (! preload || scope.loading === 'load') {
					scope.load(value);
				}
			},
			error: () => {
				if (conf.app && ! preload) {
					scope.state(true);
				}
			},
			complete: () => {
				delete scope.loading;
			}
		});
	},

	/**
	 * Set loading state
	 *
	 * @param {Boolean} [end=false]
	 */
	state(end) {
		const scope = this;
		const app = scope.$public.conf.app;

		clearTimeout(scope.loader);

		if (end) {
			app.$drop('loading');

			return;
		}

		scope.loader = setTimeout(() => {
			app.$set('loading', true);
		}, 200);
	},

	/**
	 * Load gallery images
	 *
	 * @param {Number|String} value
	 * @param {Number} [preload]
	 */
	load(value, preload) {
		const scope = this;
		const images = scope.images;

		let index;
		let numeric;

		if (preload) {
			index = preload + (value === 'next' ? 4 : -4);

			if (! images[index]) {
				return;
			}
		} else {
			if (scope.loaded) {
				scope.set(value);

				return;
			}

			numeric = Number.isInteger(value);

			if (numeric) {
				index = value - 1;
			} else {
				index = scope.index(value) - 1;
			}
		}

		const conf = scope.$public.conf;

		try {
			if (images[index].fetched) {
				if (! preload) {
					scope.set(index + 1);

					if (index % 4 === 0) {
						scope.load(value, index + 1);
					}
				}

				return;
			}
		} catch (e) {
			scope.log(e);

			return;
		}

		let targets;

		if (numeric) {
			targets = [
				images[index].path
			];

			images[index].fetched = true;
		} else {
			const range = index + (value === 'next' ? 4 : -4);
			const min = Math.min(index, range);
			const max = Math.max(index + 1, range);

			targets = LS.util.pluck(
				images.slice(min, max),
				conf.large && $.screen.size() === 1 ?
					'small' : 'path'
			);

			if (value === 'prev') {
				targets.reverse();
			}

			images.forEach((image, i) => {
				if (i >= min && i < max) {
					image.fetched = true;
				}
			});
		}

		if (targets.length < 4) {
			scope.loaded = true;

			if (! targets.length) {
				return;
			}
		}

		if (! preload && ! scope.loading) {
			scope.state();
		}

		$.assets.load({
			img: index === 1 ?
				targets.slice(0, 1) :
				targets,
			success: () => {
				if (! conf.app) {
					return;
				}

				if (index === 1 && targets.length > 1) {
					$.assets.load({
						img: targets.slice(1)
					});

					scope.load(value, index);
				}

				if (! preload) {
					scope.state(true);

					scope.set(index + 1);
				}
			}
		});
	},

	/**
	 * Process assets
	 *
	 * @param {Object} conf
	 * @param {Object} data
	 */
	process(conf, data) {
		const scope = this;

		if (scope.processed) {
			return;
		}

		conf.app.$pause();

		scope.images = this.transform(data);

		conf.app.$set('images', scope.images);

		conf.app.$resume();

		scope.processed = true;
	},

	/**
	 * Transform response
	 *
	 * @param {Object} data
	 * @returns {Array}
	 */
	transform(data) {
		const scope = this;

		try {
			const large = scope.$public.conf.large;

			return data.images.map((image, i) => {
				const ratio = image.width / image.height;
				const obj = Object.assign(image, {
					cover: ratio > 1 && ratio < 2,
					fetched: i === 0,
					path: $.get('cdnUrl') + '/listings/' + data.hash + '/' +
						(large ? 'large' : 'small') + '/' + image.key + '.jpg',
					position: i + 1
				});

				if (large) {
					obj.small = obj.path.replace('/large/', '/small/');
				} else if (! i) {
					obj.cover = true;
				}

				return obj;
			});
		} catch (e) {
			scope.log(e);
		}
	},

	/**
	 * Calculate index
	 *
	 * @param {String} value
	 * @returns {Number}
	 */
	index(value) {
		const scope = this;
		const conf = scope.$public.conf;

		let index = conf.app.$get('active_' + conf.type);

		if (value === 'next') {
			index++;

			return index > scope.total ?
				1 : index;
		}

		index--;

		return index < 1 ?
			scope.total : index;
	},

	/**
	 * Set position
	 *
	 * @param {Number|String} [value]
	 */
	set(value) {
		const scope = this;
		const conf = scope.$public.conf;
		const position = Number.isInteger(value) ?
			value : scope.index(value);

		$.exec(conf.move, {
			args: [position, scope.total]
		});

		conf.app.$set(`active_${conf.type}`, position);
	},

	/**
	 * Log error
	 *
	 * @param {String} [cause]
	 */
	log(cause) {
		LS.log.issue('GalleryError', cause, {
			listing_id: this.$public.conf.id
		});
	}
});